import { Modal, ModalFooter, Typography } from '@kc-console/common-ui';
import { useServiceAppState } from '@kc-console/context';
import { getAccountBaseUrl, useTranslation } from '@kc-console/core';

/**
 * 401 Unauthorized 에러를 처리하는 모달 컴포넌트
 * @description
 * - 토큰이 유효하지 않을 때 표시되는 모달입니다.
 * - 확인 버튼 클릭 시 로그아웃 후 로그인 페이지로 이동합니다.
 */
const Error401Modal = () => {
  const { t } = useTranslation();
  const {
    state: { iamEndpoint },
  } = useServiceAppState();

  // 로그아웃 후 로그인 페이지로 이동한다.
  const handleConfirmClick = () => {
    const currentURL = encodeURIComponent(window.location.href);
    window.location.href = `${iamEndpoint}/auth/logout?redirect_uri=${getAccountBaseUrl(
      window.location.origin,
    )}/domain?redirect_uri=${currentURL}`;
  };

  return (
    <Modal
      open
      size="sm"
      slotProps={{
        header: {
          title: t('layout:error.auth.invalid_token.title'),
        },
        body: {
          children: (
            <Typography variant="body/normal/md" style={{ whiteSpace: 'pre-wrap' }}>
              {t('layout:error.auth.invalid_token.description')}
            </Typography>
          ),
        },
        footer: {
          variantMap: {
            close: 'primary',
          },
          buttons: [
            <ModalFooter.Button
              key="error-modal-confirm"
              eventType="close"
              onClick={handleConfirmClick}
            />,
          ],
        },
      }}
    />
  );
};

export default Error401Modal;
